import { useCounts } from '@/lib/queries';

export function useNavCounts() {
  return useCounts().data;
}
